import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ReplaceCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { stroke: "currentColor", strokeLinejoin: "round", d: "M4 5h6v6H4zM14 14h6v6h-6z" }), _jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M13 5.854h4a2 2 0 0 1 2 2V10m-6-4.146L15.063 4M13 5.854 15.063 8M10 19H6a2 2 0 0 1-2-2v-2m6 4-2-2m2 2-2 2" })] }) });
}
const ReplaceCustom = forwardRef(_ReplaceCustom);
export { ReplaceCustom };
